var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"top-bar z-10"},[_c('topbar-base'),_c('h1',{staticClass:"blk-title"},[_vm._v("哈密市伊吾县智能算力统一监测")]),_c('div',{staticClass:"blk-nowdate"},[_c('div',[_vm._v(_vm._s(_vm.nowdate)+" "),_c('span',{staticClass:"pt-15"},[_vm._v(_vm._s(_vm.nowtime))])])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }